/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Web Dispatcher - spring-backend
 * API documentation for developers
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorDetails,
  ModifyCalendarEventSettingJSON,
  ModifyCalendarSettingsJSON,
  OrganizationDocumentJSON,
  OrganizationJSON,
  SaveFinagoTimeCredentialsBody,
  SettingsEsalary,
  UpdateUserMFASettingsDTO,
  UserMFAStatusDTO,
  VerifyMFARequestDTO
} from '../../model';

import { useCustomInstance } from '../../mutator/use-custom-instance.ts';
import type { ErrorType , BodyType } from '../../mutator/use-custom-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Calendar settings
 */
export const getCalendarSettings = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/settings/calendar`, method: 'GET', signal
    },
      options);
    }




export const getGetCalendarSettingsQueryKey = () => {
    return [
    `/api/v1/rest/organization/settings/calendar`
    ] as const;
    }


export const getGetCalendarSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getCalendarSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarSettings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCalendarSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarSettings>>> = ({ signal }) => getCalendarSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCalendarSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCalendarSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendarSettings>>>
export type GetCalendarSettingsQueryError = ErrorType<unknown>


export function useGetCalendarSettings<TData = Awaited<ReturnType<typeof getCalendarSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarSettings>>,
          TError,
          Awaited<ReturnType<typeof getCalendarSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarSettings<TData = Awaited<ReturnType<typeof getCalendarSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarSettings>>,
          TError,
          Awaited<ReturnType<typeof getCalendarSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarSettings<TData = Awaited<ReturnType<typeof getCalendarSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarSettings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Calendar settings
 */

export function useGetCalendarSettings<TData = Awaited<ReturnType<typeof getCalendarSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarSettings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCalendarSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Set Calendar settings (General, Annual, Sick)
 */
export const setCalendarSettings = (
    modifyCalendarSettingsJSON: BodyType<ModifyCalendarSettingsJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/organization/settings/calendar`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modifyCalendarSettingsJSON, signal
    },
      options);
    }



export const getSetCalendarSettingsMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCalendarSettings>>, TError,{data: BodyType<ModifyCalendarSettingsJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setCalendarSettings>>, TError,{data: BodyType<ModifyCalendarSettingsJSON>}, TContext> => {

const mutationKey = ['setCalendarSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCalendarSettings>>, {data: BodyType<ModifyCalendarSettingsJSON>}> = (props) => {
          const {data} = props ?? {};

          return  setCalendarSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCalendarSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setCalendarSettings>>>
    export type SetCalendarSettingsMutationBody = BodyType<ModifyCalendarSettingsJSON>
    export type SetCalendarSettingsMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Set Calendar settings (General, Annual, Sick)
 */
export const useSetCalendarSettings = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCalendarSettings>>, TError,{data: BodyType<ModifyCalendarSettingsJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCalendarSettings>>,
        TError,
        {data: BodyType<ModifyCalendarSettingsJSON>},
        TContext
      > => {
      return useMutation(getSetCalendarSettingsMutationOptions(options), queryClient);
    }
    /**
 * Fetch specific organization by business identifier from database
 * @summary Get organization by business identifier
 */
export const getOrganization = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationJSON>(
      {url: `/api/v1/rest/organization`, method: 'GET', signal
    },
      options);
    }




export const getGetOrganizationQueryKey = () => {
    return [
    `/api/v1/rest/organization`
    ] as const;
    }


export const getGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({ signal }) => getOrganization(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationQueryError = ErrorType<unknown>


export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization by business identifier
 */

export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new organization or modifies existing organization
 * @summary Create/Modify organization
 */
export const createOrganization = (
    organizationJSON: BodyType<OrganizationJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationJSON>(
      {url: `/api/v1/rest/organization`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationJSON, signal
    },
      options);
    }



export const getCreateOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: BodyType<OrganizationJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: BodyType<OrganizationJSON>}, TContext> => {

const mutationKey = ['createOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganization>>, {data: BodyType<OrganizationJSON>}> = (props) => {
          const {data} = props ?? {};

          return  createOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganization>>>
    export type CreateOrganizationMutationBody = BodyType<OrganizationJSON>
    export type CreateOrganizationMutationError = ErrorType<unknown>

    /**
 * @summary Create/Modify organization
 */
export const useCreateOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: BodyType<OrganizationJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganization>>,
        TError,
        {data: BodyType<OrganizationJSON>},
        TContext
      > => {
      return useMutation(getCreateOrganizationMutationOptions(options), queryClient);
    }
    /**
 * Create new or modify existing organization document data
 * @summary Create/Modify organization document
 */
export const createOrganizationDocument = (
    organizationId: number,
    documentId: number,
    organizationDocumentJSON: BodyType<OrganizationDocumentJSON>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationDocumentJSON>(
      {url: `/api/v1/rest/organization/${organizationId}/document/${documentId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationDocumentJSON, signal
    },
      options);
    }



export const getCreateOrganizationDocumentMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationDocument>>, TError,{organizationId: number;documentId: number;data: BodyType<OrganizationDocumentJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganizationDocument>>, TError,{organizationId: number;documentId: number;data: BodyType<OrganizationDocumentJSON>}, TContext> => {

const mutationKey = ['createOrganizationDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganizationDocument>>, {organizationId: number;documentId: number;data: BodyType<OrganizationDocumentJSON>}> = (props) => {
          const {organizationId,documentId,data} = props ?? {};

          return  createOrganizationDocument(organizationId,documentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganizationDocument>>>
    export type CreateOrganizationDocumentMutationBody = BodyType<OrganizationDocumentJSON>
    export type CreateOrganizationDocumentMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Create/Modify organization document
 */
export const useCreateOrganizationDocument = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationDocument>>, TError,{organizationId: number;documentId: number;data: BodyType<OrganizationDocumentJSON>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganizationDocument>>,
        TError,
        {organizationId: number;documentId: number;data: BodyType<OrganizationDocumentJSON>},
        TContext
      > => {
      return useMutation(getCreateOrganizationDocumentMutationOptions(options), queryClient);
    }
    /**
 * Creates a new HR API token for organization to the database
 * @summary Generate HR API token for organization
 */
export const generateHrToken = (
    businessId: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/${businessId}/token`, method: 'POST', signal
    },
      options);
    }



export const getGenerateHrTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateHrToken>>, TError,{businessId: string}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateHrToken>>, TError,{businessId: string}, TContext> => {

const mutationKey = ['generateHrToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateHrToken>>, {businessId: string}> = (props) => {
          const {businessId} = props ?? {};

          return  generateHrToken(businessId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateHrTokenMutationResult = NonNullable<Awaited<ReturnType<typeof generateHrToken>>>

    export type GenerateHrTokenMutationError = ErrorType<unknown>

    /**
 * @summary Generate HR API token for organization
 */
export const useGenerateHrToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateHrToken>>, TError,{businessId: string}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateHrToken>>,
        TError,
        {businessId: string},
        TContext
      > => {
      return useMutation(getGenerateHrTokenMutationOptions(options), queryClient);
    }
    /**
 * @summary Get eSalary settings
 */
export const getSettingsEsalary = (
    businessId: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/${businessId}/settings/esalary`, method: 'GET', signal
    },
      options);
    }




export const getGetSettingsEsalaryQueryKey = (businessId: string,) => {
    return [
    `/api/v1/rest/organization/${businessId}/settings/esalary`
    ] as const;
    }


export const getGetSettingsEsalaryQueryOptions = <TData = Awaited<ReturnType<typeof getSettingsEsalary>>, TError = ErrorType<unknown>>(businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsEsalary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsEsalaryQueryKey(businessId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsEsalary>>> = ({ signal }) => getSettingsEsalary(businessId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: businessId !== null && businessId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingsEsalary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsEsalaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsEsalary>>>
export type GetSettingsEsalaryQueryError = ErrorType<unknown>


export function useGetSettingsEsalary<TData = Awaited<ReturnType<typeof getSettingsEsalary>>, TError = ErrorType<unknown>>(
 businessId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsEsalary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsEsalary>>,
          TError,
          Awaited<ReturnType<typeof getSettingsEsalary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsEsalary<TData = Awaited<ReturnType<typeof getSettingsEsalary>>, TError = ErrorType<unknown>>(
 businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsEsalary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsEsalary>>,
          TError,
          Awaited<ReturnType<typeof getSettingsEsalary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsEsalary<TData = Awaited<ReturnType<typeof getSettingsEsalary>>, TError = ErrorType<unknown>>(
 businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsEsalary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get eSalary settings
 */

export function useGetSettingsEsalary<TData = Awaited<ReturnType<typeof getSettingsEsalary>>, TError = ErrorType<unknown>>(
 businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsEsalary>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettingsEsalaryQueryOptions(businessId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Set eSalary settings
 */
export const setSettingsEsalary = (
    businessId: string,
    settingsEsalary: BodyType<SettingsEsalary>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/${businessId}/settings/esalary`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settingsEsalary, signal
    },
      options);
    }



export const getSetSettingsEsalaryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSettingsEsalary>>, TError,{businessId: string;data: BodyType<SettingsEsalary>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSettingsEsalary>>, TError,{businessId: string;data: BodyType<SettingsEsalary>}, TContext> => {

const mutationKey = ['setSettingsEsalary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSettingsEsalary>>, {businessId: string;data: BodyType<SettingsEsalary>}> = (props) => {
          const {businessId,data} = props ?? {};

          return  setSettingsEsalary(businessId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSettingsEsalaryMutationResult = NonNullable<Awaited<ReturnType<typeof setSettingsEsalary>>>
    export type SetSettingsEsalaryMutationBody = BodyType<SettingsEsalary>
    export type SetSettingsEsalaryMutationError = ErrorType<unknown>

    /**
 * @summary Set eSalary settings
 */
export const useSetSettingsEsalary = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSettingsEsalary>>, TError,{businessId: string;data: BodyType<SettingsEsalary>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSettingsEsalary>>,
        TError,
        {businessId: string;data: BodyType<SettingsEsalary>},
        TContext
      > => {
      return useMutation(getSetSettingsEsalaryMutationOptions(options), queryClient);
    }
    /**
 * Retrieves a key-value pair for organization from the database
 * @summary Get key-value pair for organization
 */
export const getProperty = (
    businessId: string,
    key: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/${businessId}/key/${key}`, method: 'GET', signal
    },
      options);
    }




export const getGetPropertyQueryKey = (businessId: string,
    key: string,) => {
    return [
    `/api/v1/rest/organization/${businessId}/key/${key}`
    ] as const;
    }


export const getGetPropertyQueryOptions = <TData = Awaited<ReturnType<typeof getProperty>>, TError = ErrorType<unknown>>(businessId: string,
    key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyQueryKey(businessId,key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProperty>>> = ({ signal }) => getProperty(businessId,key, requestOptions, signal);





   return  { queryKey, queryFn, enabled: businessId !== null && businessId !== undefined && key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getProperty>>>
export type GetPropertyQueryError = ErrorType<unknown>


export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = ErrorType<unknown>>(
 businessId: string,
    key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProperty>>,
          TError,
          Awaited<ReturnType<typeof getProperty>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = ErrorType<unknown>>(
 businessId: string,
    key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProperty>>,
          TError,
          Awaited<ReturnType<typeof getProperty>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = ErrorType<unknown>>(
 businessId: string,
    key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get key-value pair for organization
 */

export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = ErrorType<unknown>>(
 businessId: string,
    key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyQueryOptions(businessId,key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Stores a key-value pair for organization to the database
 * @summary Store key-value pair for organization
 */
export const setProperty = (
    businessId: BodyType<string>,
    key: string,
    setPropertyBody: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/organization/${businessId}/key/${key}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setPropertyBody, signal
    },
      options);
    }



export const getSetPropertyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setProperty>>, TError,{businessId: string;key: string;data: BodyType<string>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setProperty>>, TError,{businessId: string;key: string;data: BodyType<string>}, TContext> => {

const mutationKey = ['setProperty'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setProperty>>, {businessId: string;key: string;data: BodyType<string>}> = (props) => {
          const {businessId,key,data} = props ?? {};

          return  setProperty(businessId,key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPropertyMutationResult = NonNullable<Awaited<ReturnType<typeof setProperty>>>
    export type SetPropertyMutationBody = BodyType<string>
    export type SetPropertyMutationError = ErrorType<unknown>

    /**
 * @summary Store key-value pair for organization
 */
export const useSetProperty = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setProperty>>, TError,{businessId: string;key: string;data: BodyType<string>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setProperty>>,
        TError,
        {businessId: string;key: string;data: BodyType<string>},
        TContext
      > => {
      return useMutation(getSetPropertyMutationOptions(options), queryClient);
    }
    /**
 * Deletes a key-value pair for organization from the database
 * @summary Delete key-value pair for organization
 */
export const deleteProperty = (
    businessId: string,
    key: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/organization/${businessId}/key/${key}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeletePropertyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProperty>>, TError,{businessId: string;key: string}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProperty>>, TError,{businessId: string;key: string}, TContext> => {

const mutationKey = ['deleteProperty'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProperty>>, {businessId: string;key: string}> = (props) => {
          const {businessId,key} = props ?? {};

          return  deleteProperty(businessId,key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProperty>>>

    export type DeletePropertyMutationError = ErrorType<unknown>

    /**
 * @summary Delete key-value pair for organization
 */
export const useDeleteProperty = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProperty>>, TError,{businessId: string;key: string}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProperty>>,
        TError,
        {businessId: string;key: string},
        TContext
      > => {
      return useMutation(getDeletePropertyMutationOptions(options), queryClient);
    }
    /**
 * Normalizes the integration URL (adds https://, strips trailing slash) and stores credentials
 * @summary Save Finago Time credentials
 */
export const saveFinagoTimeCredentials = (
    businessId: string,
    saveFinagoTimeCredentialsBody: BodyType<SaveFinagoTimeCredentialsBody>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/organization/${businessId}/finago-time/credentials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveFinagoTimeCredentialsBody, signal
    },
      options);
    }



export const getSaveFinagoTimeCredentialsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveFinagoTimeCredentials>>, TError,{businessId: string;data: BodyType<SaveFinagoTimeCredentialsBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof saveFinagoTimeCredentials>>, TError,{businessId: string;data: BodyType<SaveFinagoTimeCredentialsBody>}, TContext> => {

const mutationKey = ['saveFinagoTimeCredentials'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveFinagoTimeCredentials>>, {businessId: string;data: BodyType<SaveFinagoTimeCredentialsBody>}> = (props) => {
          const {businessId,data} = props ?? {};

          return  saveFinagoTimeCredentials(businessId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveFinagoTimeCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof saveFinagoTimeCredentials>>>
    export type SaveFinagoTimeCredentialsMutationBody = BodyType<SaveFinagoTimeCredentialsBody>
    export type SaveFinagoTimeCredentialsMutationError = ErrorType<unknown>

    /**
 * @summary Save Finago Time credentials
 */
export const useSaveFinagoTimeCredentials = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveFinagoTimeCredentials>>, TError,{businessId: string;data: BodyType<SaveFinagoTimeCredentialsBody>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveFinagoTimeCredentials>>,
        TError,
        {businessId: string;data: BodyType<SaveFinagoTimeCredentialsBody>},
        TContext
      > => {
      return useMutation(getSaveFinagoTimeCredentialsMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify MFA code and complete login process
 */
export const verifyMfaCode = (
    verifyMFARequestDTO: BodyType<VerifyMFARequestDTO>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<boolean>(
      {url: `/api/v1/rest/mfa/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyMFARequestDTO, signal
    },
      options);
    }



export const getVerifyMfaCodeMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfaCode>>, TError,{data: BodyType<VerifyMFARequestDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyMfaCode>>, TError,{data: BodyType<VerifyMFARequestDTO>}, TContext> => {

const mutationKey = ['verifyMfaCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyMfaCode>>, {data: BodyType<VerifyMFARequestDTO>}> = (props) => {
          const {data} = props ?? {};

          return  verifyMfaCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyMfaCodeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMfaCode>>>
    export type VerifyMfaCodeMutationBody = BodyType<VerifyMFARequestDTO>
    export type VerifyMfaCodeMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Verify MFA code and complete login process
 */
export const useVerifyMfaCode = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMfaCode>>, TError,{data: BodyType<VerifyMFARequestDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyMfaCode>>,
        TError,
        {data: BodyType<VerifyMFARequestDTO>},
        TContext
      > => {
      return useMutation(getVerifyMfaCodeMutationOptions(options), queryClient);
    }
    /**
 * @summary Create or update MFA settings for user
 */
export const upsertMfaSettings = (
    updateUserMFASettingsDTO: BodyType<UpdateUserMFASettingsDTO>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<UserMFAStatusDTO>(
      {url: `/api/v1/rest/mfa/settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserMFASettingsDTO, signal
    },
      options);
    }



export const getUpsertMfaSettingsMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMfaSettings>>, TError,{data: BodyType<UpdateUserMFASettingsDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertMfaSettings>>, TError,{data: BodyType<UpdateUserMFASettingsDTO>}, TContext> => {

const mutationKey = ['upsertMfaSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertMfaSettings>>, {data: BodyType<UpdateUserMFASettingsDTO>}> = (props) => {
          const {data} = props ?? {};

          return  upsertMfaSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertMfaSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof upsertMfaSettings>>>
    export type UpsertMfaSettingsMutationBody = BodyType<UpdateUserMFASettingsDTO>
    export type UpsertMfaSettingsMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Create or update MFA settings for user
 */
export const useUpsertMfaSettings = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMfaSettings>>, TError,{data: BodyType<UpdateUserMFASettingsDTO>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertMfaSettings>>,
        TError,
        {data: BodyType<UpdateUserMFASettingsDTO>},
        TContext
      > => {
      return useMutation(getUpsertMfaSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Calendar Event settings
 */
export const getCalendarEventSettings = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/settings/calendar/events`, method: 'GET', signal
    },
      options);
    }




export const getGetCalendarEventSettingsQueryKey = () => {
    return [
    `/api/v1/rest/organization/settings/calendar/events`
    ] as const;
    }


export const getGetCalendarEventSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getCalendarEventSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEventSettings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCalendarEventSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarEventSettings>>> = ({ signal }) => getCalendarEventSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCalendarEventSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCalendarEventSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendarEventSettings>>>
export type GetCalendarEventSettingsQueryError = ErrorType<unknown>


export function useGetCalendarEventSettings<TData = Awaited<ReturnType<typeof getCalendarEventSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEventSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarEventSettings>>,
          TError,
          Awaited<ReturnType<typeof getCalendarEventSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarEventSettings<TData = Awaited<ReturnType<typeof getCalendarEventSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEventSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarEventSettings>>,
          TError,
          Awaited<ReturnType<typeof getCalendarEventSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCalendarEventSettings<TData = Awaited<ReturnType<typeof getCalendarEventSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEventSettings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Calendar Event settings
 */

export function useGetCalendarEventSettings<TData = Awaited<ReturnType<typeof getCalendarEventSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarEventSettings>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCalendarEventSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update Calendar Event settings (Active/Inactive status)
 */
export const setCalendarEventSettings = (
    modifyCalendarEventSettingJSON: BodyType<ModifyCalendarEventSettingJSON[]>,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<void>(
      {url: `/api/v1/rest/organization/settings/calendar/events`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: modifyCalendarEventSettingJSON, signal
    },
      options);
    }



export const getSetCalendarEventSettingsMutationOptions = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCalendarEventSettings>>, TError,{data: BodyType<ModifyCalendarEventSettingJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setCalendarEventSettings>>, TError,{data: BodyType<ModifyCalendarEventSettingJSON[]>}, TContext> => {

const mutationKey = ['setCalendarEventSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCalendarEventSettings>>, {data: BodyType<ModifyCalendarEventSettingJSON[]>}> = (props) => {
          const {data} = props ?? {};

          return  setCalendarEventSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCalendarEventSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setCalendarEventSettings>>>
    export type SetCalendarEventSettingsMutationBody = BodyType<ModifyCalendarEventSettingJSON[]>
    export type SetCalendarEventSettingsMutationError = ErrorType<ErrorDetails>

    /**
 * @summary Update Calendar Event settings (Active/Inactive status)
 */
export const useSetCalendarEventSettings = <TError = ErrorType<ErrorDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCalendarEventSettings>>, TError,{data: BodyType<ModifyCalendarEventSettingJSON[]>}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCalendarEventSettings>>,
        TError,
        {data: BodyType<ModifyCalendarEventSettingJSON[]>},
        TContext
      > => {
      return useMutation(getSetCalendarEventSettingsMutationOptions(options), queryClient);
    }
    /**
 * Import organizations from eSalary
 * @summary Import organizations
 */
export const importOrganizations = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<boolean>(
      {url: `/api/v1/rest/organizations/import`, method: 'GET', signal
    },
      options);
    }




export const getImportOrganizationsQueryKey = () => {
    return [
    `/api/v1/rest/organizations/import`
    ] as const;
    }


export const getImportOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof importOrganizations>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importOrganizations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof importOrganizations>>> = ({ signal }) => importOrganizations(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImportOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof importOrganizations>>>
export type ImportOrganizationsQueryError = ErrorType<unknown>


export function useImportOrganizations<TData = Awaited<ReturnType<typeof importOrganizations>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof importOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importOrganizations>>,
          TError,
          Awaited<ReturnType<typeof importOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImportOrganizations<TData = Awaited<ReturnType<typeof importOrganizations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importOrganizations>>,
          TError,
          Awaited<ReturnType<typeof importOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImportOrganizations<TData = Awaited<ReturnType<typeof importOrganizations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importOrganizations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Import organizations
 */

export function useImportOrganizations<TData = Awaited<ReturnType<typeof importOrganizations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importOrganizations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImportOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of organizations from database
 * @summary Get all organizations
 */
export const getAllOrganizations = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationJSON[]>(
      {url: `/api/v1/rest/organizations/all`, method: 'GET', signal
    },
      options);
    }




export const getGetAllOrganizationsQueryKey = () => {
    return [
    `/api/v1/rest/organizations/all`
    ] as const;
    }


export const getGetAllOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getAllOrganizations>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOrganizations>>> = ({ signal }) => getAllOrganizations(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOrganizations>>>
export type GetAllOrganizationsQueryError = ErrorType<ErrorDetails>


export function useGetAllOrganizations<TData = Awaited<ReturnType<typeof getAllOrganizations>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getAllOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOrganizations<TData = Awaited<ReturnType<typeof getAllOrganizations>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getAllOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOrganizations<TData = Awaited<ReturnType<typeof getAllOrganizations>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all organizations
 */

export function useGetAllOrganizations<TData = Awaited<ReturnType<typeof getAllOrganizations>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch list of organizations from database that were modified after provided timestamp
 * @summary Get all organizations that were modified after provided timestamp
 */
export const getAllOrganizationsModifiedSince = (
    modifiedSince: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationJSON[]>(
      {url: `/api/v1/rest/organizations/all/modified/${modifiedSince}`, method: 'GET', signal
    },
      options);
    }




export const getGetAllOrganizationsModifiedSinceQueryKey = (modifiedSince: number,) => {
    return [
    `/api/v1/rest/organizations/all/modified/${modifiedSince}`
    ] as const;
    }


export const getGetAllOrganizationsModifiedSinceQueryOptions = <TData = Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError = ErrorType<ErrorDetails>>(modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOrganizationsModifiedSinceQueryKey(modifiedSince);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>> = ({ signal }) => getAllOrganizationsModifiedSince(modifiedSince, requestOptions, signal);





   return  { queryKey, queryFn, enabled: modifiedSince !== null && modifiedSince !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllOrganizationsModifiedSinceQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>>
export type GetAllOrganizationsModifiedSinceQueryError = ErrorType<ErrorDetails>


export function useGetAllOrganizationsModifiedSince<TData = Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>,
          TError,
          Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOrganizationsModifiedSince<TData = Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>,
          TError,
          Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOrganizationsModifiedSince<TData = Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all organizations that were modified after provided timestamp
 */

export function useGetAllOrganizationsModifiedSince<TData = Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError = ErrorType<ErrorDetails>>(
 modifiedSince: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationsModifiedSince>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllOrganizationsModifiedSinceQueryOptions(modifiedSince,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Retrieves a list of active integration keys for organization from the database
 * @summary Get active integrations for organization
 */
export const getActiveIntegrations = (
    businessId: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/${businessId}/integrations`, method: 'GET', signal
    },
      options);
    }




export const getGetActiveIntegrationsQueryKey = (businessId: string,) => {
    return [
    `/api/v1/rest/organization/${businessId}/integrations`
    ] as const;
    }


export const getGetActiveIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof getActiveIntegrations>>, TError = ErrorType<unknown>>(businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveIntegrations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveIntegrationsQueryKey(businessId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveIntegrations>>> = ({ signal }) => getActiveIntegrations(businessId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: businessId !== null && businessId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveIntegrations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActiveIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveIntegrations>>>
export type GetActiveIntegrationsQueryError = ErrorType<unknown>


export function useGetActiveIntegrations<TData = Awaited<ReturnType<typeof getActiveIntegrations>>, TError = ErrorType<unknown>>(
 businessId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveIntegrations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getActiveIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveIntegrations<TData = Awaited<ReturnType<typeof getActiveIntegrations>>, TError = ErrorType<unknown>>(
 businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveIntegrations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getActiveIntegrations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveIntegrations<TData = Awaited<ReturnType<typeof getActiveIntegrations>>, TError = ErrorType<unknown>>(
 businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveIntegrations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get active integrations for organization
 */

export function useGetActiveIntegrations<TData = Awaited<ReturnType<typeof getActiveIntegrations>>, TError = ErrorType<unknown>>(
 businessId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveIntegrations>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveIntegrationsQueryOptions(businessId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch all organization documents from database
 * @summary Get all organization documents
 */
export const getAllOrganizationDocuments = (
    businessIdentifier: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationDocumentJSON>(
      {url: `/api/v1/rest/organization/${businessIdentifier}/documents`, method: 'GET', signal
    },
      options);
    }




export const getGetAllOrganizationDocumentsQueryKey = (businessIdentifier: string,) => {
    return [
    `/api/v1/rest/organization/${businessIdentifier}/documents`
    ] as const;
    }


export const getGetAllOrganizationDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError = ErrorType<ErrorDetails>>(businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOrganizationDocumentsQueryKey(businessIdentifier);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOrganizationDocuments>>> = ({ signal }) => getAllOrganizationDocuments(businessIdentifier, requestOptions, signal);





   return  { queryKey, queryFn, enabled: businessIdentifier !== null && businessIdentifier !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllOrganizationDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOrganizationDocuments>>>
export type GetAllOrganizationDocumentsQueryError = ErrorType<ErrorDetails>


export function useGetAllOrganizationDocuments<TData = Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError = ErrorType<ErrorDetails>>(
 businessIdentifier: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrganizationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllOrganizationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOrganizationDocuments<TData = Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError = ErrorType<ErrorDetails>>(
 businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrganizationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllOrganizationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOrganizationDocuments<TData = Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError = ErrorType<ErrorDetails>>(
 businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all organization documents
 */

export function useGetAllOrganizationDocuments<TData = Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError = ErrorType<ErrorDetails>>(
 businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrganizationDocuments>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllOrganizationDocumentsQueryOptions(businessIdentifier,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get Organization Vacation Years
 */
export const getVacationYears = (

 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<unknown>(
      {url: `/api/v1/rest/organization/vacation-years`, method: 'GET', signal
    },
      options);
    }




export const getGetVacationYearsQueryKey = () => {
    return [
    `/api/v1/rest/organization/vacation-years`
    ] as const;
    }


export const getGetVacationYearsQueryOptions = <TData = Awaited<ReturnType<typeof getVacationYears>>, TError = ErrorType<ErrorDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVacationYears>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVacationYearsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVacationYears>>> = ({ signal }) => getVacationYears(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVacationYears>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVacationYearsQueryResult = NonNullable<Awaited<ReturnType<typeof getVacationYears>>>
export type GetVacationYearsQueryError = ErrorType<ErrorDetails>


export function useGetVacationYears<TData = Awaited<ReturnType<typeof getVacationYears>>, TError = ErrorType<ErrorDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVacationYears>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVacationYears>>,
          TError,
          Awaited<ReturnType<typeof getVacationYears>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVacationYears<TData = Awaited<ReturnType<typeof getVacationYears>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVacationYears>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVacationYears>>,
          TError,
          Awaited<ReturnType<typeof getVacationYears>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVacationYears<TData = Awaited<ReturnType<typeof getVacationYears>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVacationYears>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Vacation Years
 */

export function useGetVacationYears<TData = Awaited<ReturnType<typeof getVacationYears>>, TError = ErrorType<ErrorDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVacationYears>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVacationYearsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Fetch specific organization document from database
 * @summary Get organization document
 */
export const getOrganizationDocument = (
    documentId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationDocumentJSON>(
      {url: `/api/v1/rest/organization/document/${documentId}`, method: 'GET', signal
    },
      options);
    }




export const getGetOrganizationDocumentQueryKey = (documentId: number,) => {
    return [
    `/api/v1/rest/organization/document/${documentId}`
    ] as const;
    }


export const getGetOrganizationDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationDocument>>, TError = ErrorType<ErrorDetails>>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocument>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationDocumentQueryKey(documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationDocument>>> = ({ signal }) => getOrganizationDocument(documentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationDocument>>>
export type GetOrganizationDocumentQueryError = ErrorType<ErrorDetails>


export function useGetOrganizationDocument<TData = Awaited<ReturnType<typeof getOrganizationDocument>>, TError = ErrorType<ErrorDetails>>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDocument>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDocument<TData = Awaited<ReturnType<typeof getOrganizationDocument>>, TError = ErrorType<ErrorDetails>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDocument>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDocument<TData = Awaited<ReturnType<typeof getOrganizationDocument>>, TError = ErrorType<ErrorDetails>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocument>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization document
 */

export function useGetOrganizationDocument<TData = Awaited<ReturnType<typeof getOrganizationDocument>>, TError = ErrorType<ErrorDetails>>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDocument>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationDocumentQueryOptions(documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Delete a single document
 * @summary Delete organization document
 */
export const deleteOrgaznizationDocument = (
    documentId: number,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationDocumentJSON>(
      {url: `/api/v1/rest/organization/document/${documentId}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteOrgaznizationDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgaznizationDocument>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgaznizationDocument>>, TError,{documentId: number}, TContext> => {

const mutationKey = ['deleteOrgaznizationDocument'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgaznizationDocument>>, {documentId: number}> = (props) => {
          const {documentId} = props ?? {};

          return  deleteOrgaznizationDocument(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgaznizationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgaznizationDocument>>>

    export type DeleteOrgaznizationDocumentMutationError = ErrorType<unknown>

    /**
 * @summary Delete organization document
 */
export const useDeleteOrgaznizationDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgaznizationDocument>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgaznizationDocument>>,
        TError,
        {documentId: number},
        TContext
      > => {
      return useMutation(getDeleteOrgaznizationDocumentMutationOptions(options), queryClient);
    }
    /**
 * Fetch specific organization by business identifier from database
 * @summary Get organization by business identifier
 */
export const getOrganization1 = (
    businessIdentifier: string,
 options?: SecondParameter<typeof useCustomInstance>,signal?: AbortSignal
) => {


      return useCustomInstance<OrganizationJSON>(
      {url: `/api/v1/rest/organization/${businessIdentifier}`, method: 'GET', signal
    },
      options);
    }




export const getGetOrganization1QueryKey = (businessIdentifier: string,) => {
    return [
    `/api/v1/rest/organization/${businessIdentifier}`
    ] as const;
    }


export const getGetOrganization1QueryOptions = <TData = Awaited<ReturnType<typeof getOrganization1>>, TError = ErrorType<unknown>>(businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization1>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganization1QueryKey(businessIdentifier);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization1>>> = ({ signal }) => getOrganization1(businessIdentifier, requestOptions, signal);





   return  { queryKey, queryFn, enabled: businessIdentifier !== null && businessIdentifier !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganization1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganization1QueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization1>>>
export type GetOrganization1QueryError = ErrorType<unknown>


export function useGetOrganization1<TData = Awaited<ReturnType<typeof getOrganization1>>, TError = ErrorType<unknown>>(
 businessIdentifier: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization1>>,
          TError,
          Awaited<ReturnType<typeof getOrganization1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization1<TData = Awaited<ReturnType<typeof getOrganization1>>, TError = ErrorType<unknown>>(
 businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization1>>,
          TError,
          Awaited<ReturnType<typeof getOrganization1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization1<TData = Awaited<ReturnType<typeof getOrganization1>>, TError = ErrorType<unknown>>(
 businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization1>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization by business identifier
 */

export function useGetOrganization1<TData = Awaited<ReturnType<typeof getOrganization1>>, TError = ErrorType<unknown>>(
 businessIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization1>>, TError, TData>>, request?: SecondParameter<typeof useCustomInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganization1QueryOptions(businessIdentifier,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






